import React from 'react';

import { LayoutDynamicZone } from 'src/modules/layout';
import Link from 'next/link';
import 'moment/locale/de';
import { LayoutPage, LayoutBlockText } from 'src/modules/layout';
import { rowTextBlockProps } from 'src/utils/grid';
import { Row, Col } from 'antd';
import { JobTypes } from 'src/modules/jobs'; //getJobTypeRow, getJobDateRow, getJobLocationRow
import { useIntl } from 'react-intl';
import 'moment/locale/de';
import { useLocale } from 'src/modules/locale';
import styles from './JobsListingPage.module.scss';
import { JobEntity, JobLocalizedEntity } from 'src/modules/jobs';

interface JobsTableProps {
  jobs: JobLocalizedEntity[];
  titleKey: string;
  headline: string;
}

const JobsTable: React.FunctionComponent<JobsTableProps> = ({ headline, jobs, titleKey }) => {
  const intl = useIntl();
  // const { locale } = useLocale();
  return (
    <div className={styles.jobs}>
      <div className={styles.headline}>
        <LayoutBlockText body_text={headline} />
      </div>
      <Row {...rowTextBlockProps}>
        <Col xs={24} md={{ span: 12, offset: 6 }}>
          <div className={styles.category}>{intl.formatMessage({ id: titleKey })}</div>
          {jobs.map((job) => {
            const { title } = job; //city, type, start_date,
            return (
              <Link key={job.id} href="/about/careers/[slug]" as={`/about/careers/${job.slug}`}>
                <a>
                  <div className={styles.job}>
                    <div className={styles.title}>{title}</div>
                    {/* <div className={styles.details}>
                      <div>{getJobLocationRow(city, intl)}</div>
                      <div>{getJobTypeRow(type, intl)}</div>
                      <div>{getJobDateRow(start_date, locale, intl)}</div>
                    </div> */}
                  </div>
                </a>
              </Link>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

type JobsListingPageProps = {
  careersPage: {
    jobs: JobEntity[];
  };
};

const JobsListingPage: React.FunctionComponent<JobsListingPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject, locale } = useLocale();

  const { careersPage = {} as any } = getLocalizedObject(props);
  const jobs: JobLocalizedEntity[] = careersPage.jobs;

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/careers/listing/head/page_title' }),
    description: intl.formatMessage({ id: 'page/careers/listing/head/meta_description' }),
    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/careers',
        }),
        as: '/about/careers',
        href: '/about/careers',
      },
    ],
  };

  const {
    dynamic_content_top,
    dynamic_content_bottom,
    normal_jobs_headline,
    educational_jobs_headline,
  } = careersPage?.career || {};

  const generaljobs: JobLocalizedEntity[] = [];
  const internshipJobs: JobLocalizedEntity[] = [];

  jobs.forEach((job) => {
    if (!(job.only_german && locale === 'en')) {
      (job.type === JobTypes.Internship ||
      job.type === JobTypes.DegreeProgram ||
      job.type === JobTypes.IndustrialTraining ||
      job.type === JobTypes.BusinessManagement
        ? internshipJobs
        : generaljobs
      ).push(job);
    }
  });

  return (
    <LayoutPage {...pageProperties}>
      {!!dynamic_content_top && (
        <LayoutDynamicZone components={dynamic_content_top} groupCards={true} />
      )}

      <JobsTable
        jobs={generaljobs}
        titleKey={
          generaljobs.length
            ? 'page/careers/listing/general_jobs_title'
            : 'page/careers/listing/no_jobs'
        }
        headline={normal_jobs_headline}
      />

      {locale === 'de' && (
        <JobsTable
          jobs={internshipJobs}
          titleKey={
            internshipJobs.length
              ? 'page/careers/listing/ausbildung_jobs_title'
              : 'page/careers/listing/no_jobs'
          }
          headline={educational_jobs_headline}
        />
      )}
      {!!dynamic_content_bottom && (
        <LayoutDynamicZone components={dynamic_content_bottom} groupCards={true} />
      )}
    </LayoutPage>
  );
};

export default JobsListingPage;
